























































import { defineComponent, reactive, toRefs, PropType, computed, watch, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../commons/common"
import ScoreStampPreviewBox from "./ScoreStampPreviewBox.vue";

export interface Data {
  headerHeight: number
  footerHeight: number
  colCount: number
  scale: number
  fieldPadding: number
  fieldMargin: number
  fieldWrapWidth: number
  fieldWrapHeight: number
  fieldImageWidth: number
  fieldImageHeight: number
  scrollBarSize: number
}

export default defineComponent({

  components: {
    "score-stamp-preview-box": ScoreStampPreviewBox,
  },
  props: {
    sheet_id: {
      type: String
    },
    fieldActivities: {
      type: Array as PropType<any[]>
    },
    sheetField: {
      type: Object as PropType<any>
    },
    selectedIdx: {
      type: Number
    },
    visible: {
      type: Boolean
    },
    windowHeight: {
      type: Number
    },
    isDispStudentInfo: {
      type: Boolean
    },
    sortKind: {
      type: Number
    },
  },
  setup (props, context) {

    const SortKindEnum = Common.SaitenInputSortKindEnum;

    /************************************************************
     * Data
     ************************************************************/

    const state = reactive<Data>({
      headerHeight: 50,
      footerHeight: 50,
      colCount: 5,
      scale: 0,
      fieldPadding: 8,
      fieldMargin: 5,
      fieldWrapWidth: 0,
      fieldWrapHeight: 0,
      fieldImageWidth: 0,
      fieldImageHeight: 0,
      scrollBarSize: 0,
    });

    /************************************************************
     * 画像領域の高さ
     ************************************************************/

     const imageAreaHeight = computed((): number => {
      return props.windowHeight - state.headerHeight - state.footerHeight;
    });

    /************************************************************
     * サイドバーClose
     ************************************************************/

     const hiddenSidebar = () => {
      context.emit("hidden");
    }

    /************************************************************
     * 列数変更による拡大・縮小
     ************************************************************/

     const changeColCount = (addValue: number) => {
      blur();
      if(state.colCount + addValue <= 0){
        return;
      }

      state.colCount += addValue;
      adjustLayout();
    }

    /************************************************************
     * 画面のレイアウト整形
     * 初期表示・ウィンドウリサイズ・拡大縮小ボタン押下時に発動
     ************************************************************/

    const adjustLayout = () => {

      const imageArea = document.getElementById("preview-image-area");

      // 画像1件あたりの縦横サイズを整形
      state.fieldWrapWidth = Math.floor((imageArea.clientWidth - state.colCount) / state.colCount - (state.fieldMargin * 2));
      state.fieldImageWidth = state.fieldWrapWidth - (state.fieldPadding * 2);
      state.scale = state.fieldImageWidth / (props.sheetField.baseWidth);
      state.fieldImageHeight = Math.round((props.sheetField.baseHeight) * state.scale);
      state.fieldWrapHeight = state.fieldImageHeight + state.fieldPadding * 2;
    };

    /************************************************************
     * visible監視
     * true(表示)に変わったらレイアウト成型
     ************************************************************/

    watch(() => props.visible, (newVal) => {
      if(newVal){
        adjustLayout();
        
        // 選択中の設問へ自動スクロール
        const selectedBox = document.getElementById(`preview-box-${props.selectedIdx}`);
        const toPos = selectedBox.offsetTop - parseInt(window.getComputedStyle(selectedBox).marginTop);
        const imageArea = document.getElementById("preview-image-area");
        imageArea.scrollTop = toPos;
      }
    });

    /************************************************************
     * ソート順変更
     ************************************************************/

    const changeSortKind = (sortKind: number) => {
      context.emit("change-sort-kind", sortKind);
    }

    /************************************************************
     * 設問クリックによる選択設問変更
     ************************************************************/

    const fieldClicked = (idx: number) => {
      context.emit("field-clicked", idx);
    }

    /************************************************************
     * ショートカットキー押下
     ************************************************************/

    const keyDown = async (e: KeyboardEvent) => {
      
      if(!props.visible){
        return;
      }
      
      e.preventDefault();

      if(["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(e.key)){
        let nextIdx = 0;

        if(e.key == "ArrowLeft"){
          // 左矢印 前の設問へ
          nextIdx = props.selectedIdx - 1;
        }else if(e.key == "ArrowRight"){
          // 右矢印 次の設問へ
          nextIdx =  props.selectedIdx + 1;
        }else{
          const row = Math.floor(props.selectedIdx / state.colCount);
          const col = props.selectedIdx % state.colCount;
          if(e.key == "ArrowUp"){
            // 上矢印 上の行の設問へ
            nextIdx = ((row - 1) * state.colCount) + col;
          }else if(e.key == "ArrowDown"){
            // 下矢印 下の行の設問へ
            nextIdx = ((row + 1) * state.colCount) + col;
          }
        }

        // インデックスが範囲外の場合は処理終了
        if(nextIdx < 0 || nextIdx + 1 > props.fieldActivities.length){
          return;
        }

        context.emit("field-clicked", nextIdx);
        
        // 選択中の設問へ自動スクロール
        const nowBox = document.getElementById(`preview-box-${props.selectedIdx}`);
        const nextBox = document.getElementById(`preview-box-${nextIdx}`);
        if(nowBox.offsetTop != nextBox.offsetTop){
          const imageArea = document.getElementById("preview-image-area");
          const fromPos = imageArea.scrollTop - parseInt(window.getComputedStyle(nextBox).marginTop);
          const toPos = nextBox.offsetTop - parseInt(window.getComputedStyle(nextBox).marginTop);
          Common.smoothScroll(fromPos, toPos, 0, 0, imageArea);
        }
      }
    };

    /************************************************************
     * onmount windowイベント登録
     ************************************************************/
    onMounted(async () => {
      window.addEventListener("keydown", keyDown);
      window.addEventListener("resize", adjustLayout);
    });

    /************************************************************
     * before unmount windowイベント解除
     ************************************************************/
    onBeforeUnmount(async () => {
      window.removeEventListener("keydown", keyDown);
      window.removeEventListener("resize", adjustLayout);
    });

    return {
      ...toRefs(state),
      SortKindEnum,
      changeColCount,
      imageAreaHeight,
      hiddenSidebar,
      changeSortKind,
      fieldClicked,
    }
  }
});
